// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/complete-integration-call-request-schema',
  type: 'object',
  required: ['userId', 'comment', 'id'],
  properties: {
    userId: {
      type: 'integer',
    },
    comment: {
      type: 'string',
      minLength: 1,
    },
    id: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
